import { render, staticRenderFns } from "./AdminPanelPage.vue?vue&type=template&id=0c08cb55&scoped=true"
import script from "./AdminPanelPage.vue?vue&type=script&lang=js"
export * from "./AdminPanelPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c08cb55",
  null
  
)

export default component.exports